<template>
  <div>
    <!-- 图片（预览） -->
    <div class="value-show" v-if="value && fileType === 'image'">
      <ul v-if="Array.isArray(value)">
        <li v-for="img in value" :key="img">
          <img :src="`${Config.staticURL}${img}`" />
          <a-button type="danger" size="small" @click="deleteValue(img)">
            {{ $t('com_btn_remove') }}
          </a-button>
        </li>
      </ul>
      <ul v-else>
        <li>
          <img :src="`${Config.staticURL}${value}`" />
          <a-button type="danger" size="small" @click="deleteValue(value)">
            {{ $t('com_btn_remove') }}
          </a-button>
        </li>
      </ul>
    </div>

    <!-- 附件 -->
    <div class="value-file-show" v-if="value && fileType === 'file'">
      <dl v-if="Array.isArray(value)">
        <dd v-for="file in value" :key="file">
          <div class="file-name">
            <a-icon type="paper-clip" />
            <div :title="file">
              {{ file }}
            </div>
          </div>

          <div class="file-delete">
            <a-icon type="delete" @click="deleteValue(file)" />
          </div>
        </dd>
      </dl>
      <dl v-else>
        <dd>
          <div class="file-name">
            <a-icon type="paper-clip" />
            <div :title="value">
              {{ value }}
            </div>
          </div>
          <div class="file-delete">
            <button type="text" v-if="attachmentDeleteLoading" :loading="attachmentDeleteLoading">
              {{ $t('com_ongoing_remove') }}
            </button>
            <a-icon type="delete" @click="deleteValue(value)" v-else />
          </div>
        </dd>
      </dl>
    </div>
    <a-upload-dragger
      :multiple="multi"
      :file-list="fileList"
      :before-upload="beforeUpload"
      :list-type="listType"
      @preview="handlePreview"
      @change="handleChange"
      class="upload-area"
    >
      <div class="upload-description">
        <p class="ant-upload-drag-icon" style="margin:0 10px 0 0;">
          <a-icon type="inbox" />
        </p>
        <div>
          <p class="ant-upload-text">
            {{ $t('com_upload_tip1') }}
          </p>
          <p class="ant-upload-hint">
            {{ $t('com_upload_only_text') }}
            <span class="highlight">{{ fileTypeText.join('/') }}</span>
            {{ $t('com_upload_tip3') }}
            <span class="highlight">
              {{ formatSize() }}
            </span>
          </p>
        </div>
      </div>
    </a-upload-dragger>
    <a-modal
      :visible="previewVisible"
      :footer="null"
      @cancel="handleCancel"
      centered
      destroyOnClose
    >
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>
<script>
import { getBase64 } from '@/libs/utils';
import Config from '@/config';
// import * as CommonAPI from '@/api/common';

export default {
  props: {
    multi: {
      type: Boolean,
      default: false,
    },
    file: {
      type: [Array, Object, String, Number],
    },
    // 原文件
    src: {
      type: [Array, Object, String],
    },

    // 展示类型
    listType: {
      type: String,
      // text,picture,picture-card
      default: 'picture',
    },

    // 类型
    fileType: {
      type: String, // image=>图片，file=>附件
      default: 'image',
    },

    // 允许上传文件
    fileTypes: {
      type: [Array],
      default: () => [
        '.jpg',
        '.png',
        '.doc',
        '.docx',
        '.excel',
        '.zip',
        '.gz',
        '.data',
        '.json',
        '.txt',
        '.csv',
      ],
    },

    // 类型展示用
    fileTypeText: {
      type: Array,
      default: () => ['jpg', 'png', 'word', 'excel', 'gz', 'zip', 'json', 'txt'],
    },

    // 最大允许值
    fileMaxSize: {
      type: [Number],
      // 默认50M
      default: 50 * 1024 * 1024,
    },
  },
  created() {
    if (typeof this.file === 'string') {
      this.value = this.file;

      // this.fileList = [
      //   {
      //     uid: '-1',
      //     name: this.file,
      //     status: 'done',
      //     url: `${Config.staticURL}${this.file}`,
      //   },
      // ];
    }
  },
  data() {
    return {
      Config,
      fileList: [],
      value: null,

      attachmentDeleteLoading: false,
      previewVisible: false,
      previewImage: '',
    };
  },
  watch: {
    file(value) {
      this.value = value;
    },
  },
  methods: {
    beforeUpload(_file, _fileList) {
      return false;
    },

    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },

    handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = file.thumbUrl;
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },

    handleCancel() {
      this.previewVisible = false;
    },

    formatSize() {
      const size =
        this.fileMaxSize / (1024 * 1024) > 1
          ? this.fileMaxSize / (1024 * 1024) + 'M'
          : this.fileMaxSize / (1024 * 1024) + 'KB';
      return size;
    },

    // 上传-change
    // file,fileList,event
    async handleChange({ file, fileList }) {
      if (!file.url && !file.preview) {
        file.thumbUrl = await getBase64(file.originFileObj || file);
      }

      if (this.multi) {
        this.fileList = fileList;
      } else {
        if (file.status === 'removed') {
          this.fileList = [];
        } else {
          this.fileList = [file];
        }
      }
      this.$emit('change', this.name, this.fileList);
    },

    // 验证上传文件
    checkUpload(rule, value, callback) {
      if (value && Array.isArray(value)) {
        value.forEach(file => {
          const fileName = file.name;
          const extName = '.' + fileName.substring(fileName.lastIndexOf('.') + 1);
          if (!this.fileTypes.includes(extName)) {
            callback(
              new Error(
                this.$t('com_upload_type_error', {
                  typeList: this.fileTypeText.join(' / '),
                })
              )
            );
          } else if (file.size > this.fileMaxSize) {
            callback(new Error(this.$t('com_upload_size_error', { maxSize: this.formatSize() })));
          }
        });
      }
      callback();
    },

    // 清除
    clearFile() {
      this.fileList = [];
    },

    // 删除
    deleteValue(_filePath) {
      this.$emit('change', 'deleteAttachment', '');
    },
  },
};
</script>
<style lang="less" scoped>
.value-show {
  overflow: hidden;
  border-radius: 5px;
  margin-bottom: 10px;
  padding-top: 10px;

  ul {
    margin: 0;
    padding: 0;
    li {
      margin: 0;
      padding: 5px;
      position: relative;
      border: #e5e5e5 solid 1px;
      border-radius: 5px;
      overflow: hidden;
      img {
        width: auto;
        max-width: 100%;
        max-height: 100px;
        border-radius: 5px;
      }
      button {
        position: absolute;
        right: 5px;
        top: 5px;
      }
    }
  }
}

.upload-description {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: left;
  .highlight {
    color: #e91e63;
  }
}

.value-file-show {
  dl {
    margin-top: 10px;
    dd {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: #eee solid 1px;
      border-radius: 4px;
      height: 22px;
      &:hover {
        background: #e6f4f5;
      }

      .file-name {
        display: flex;
        width: 80%;
        align-items: center;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;

        .anticon {
          margin: 0 6px;
        }
      }

      .file-delete {
        .anticon {
          margin-right: 6px;
          cursor: pointer;
        }
      }
    }
  }
}

::v-deep .upload-area {
  .ant-upload {
    margin-bottom: 10px;
    &.ant-upload-drag {
      .ant-upload-btn {
        padding: 5px 0;

        p.ant-upload-text {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
